// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { PickerProps } from 'antd/lib/date-picker/generatePicker';
import 'antd/lib/date-picker/style/index';
import dayjs, { Dayjs } from 'dayjs';

import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localeData from 'dayjs/plugin/localeData';
import weekday from 'dayjs/plugin/weekday';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekYear from 'dayjs/plugin/weekYear';

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);

import { DateFormats } from '@/constants/dates';
import { CalendarIcon } from '@/icons';
import { StyledDatePicker } from './DatePickerStyles';

type IDatePicker = PickerProps<Dayjs>;

const DatePicker = ({ value, onChange, ...props }: IDatePicker) => (
  <StyledDatePicker
    {...props}
    value={value}
    onChange={onChange}
    placeholder=""
    format={DateFormats.DEFAULT}
    suffixIcon={<CalendarIcon />}
    onFocus={(e) => e.target.blur()}
  />
);

export default DatePicker;
